/**
 * @param {boolean} smallView
 */
export function setSmallView (smallView) {
    return {
        type: 'SET_SMALL_VIEW',
        smallView
    }
}
